export default __webpack_public_path__ + "9e0eca3efba01e295b5c2c617deecc6a.svg";